import { io } from 'socket.io-client';
import { BACKEND_URL } from './Constants';

let socket;

//dev http://localhost:5000

//live

export const connectSocket = () => {
  socket = io(`${ BACKEND_URL }`, {
    auth: {
      token: localStorage.getItem('token'),
    }
  });
};

export const getSocket = () => socket;
